import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import { connect } from "react-redux";
import moment from "moment";
import { Grid, Button, TextField } from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { getCenters } from "../../actions/GenomicsAdminAction";
import Autocomplete from "@material-ui/lab/Autocomplete";
const useStyles = makeStyles((theme) => ({
  paper: {
    border: "1px solid",
    borderRadius: 10,
    padding: theme.spacing(1),
    backgroundColor: "white",
    marginTop: "30px",
    marginRight: "20px",
    color: "#424242",
    zIndex: 2,
    width: 500,
    height: "60vh",
  },
}));
interface Props {
  getCenters: any;
  centers: any;
  setAnchorElUpdate: any;
  anchorElUpdate: any;
  id: any;
}

const SystemUpdateDetails: React.FC<Props> = ({
  getCenters,
  centers,
  setAnchorElUpdate,
  anchorElUpdate,
  id,
}) => {
  const classes = useStyles();
  const open = Boolean(anchorElUpdate);
  const [centre, setCentreId] = React.useState<string>("");

  useEffect(() => {
    getCenters();
  }, []);

  return (
    <div>
      <Popper id={id} open={open} anchorEl={anchorElUpdate} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className={classes.paper}>
              gnadmin Message:
              <hr />
              <li>
                All CC update their KYC
                <sub>({moment().format("DD-MM-YYYY")})</sub>
              </li>
              <hr />
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Autocomplete
                      id="center-name"
                      onChange={(event, newValue) => {
                        if (newValue) {
                          let obj = JSON.parse(
                            JSON.stringify(newValue, null, " ")
                          );
                          setCentreId(obj.id);
                        }
                      }}
                      options={centers.results || []}
                      freeSolo
                      blurOnSelect
                      aria-required
                      getOptionLabel={(option: any) => option?.name}
                      onInputChange={(event, newInputValue) => {
                        getCenters(`?name=${newInputValue}`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="Select Center"
                          variant="outlined"
                          required
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextareaAutosize
                      aria-label="Type Message"
                      minRows={2}
                      placeholder="Type Message"
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      variant="contained"
                      fullWidth
                      size="small"
                      color="primary"
                    >
                      Send
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  centers: state.GenomicsAdminReducer.centers,
});

export default connect(mapStateToProps, {
  getCenters,
})(SystemUpdateDetails);
